// Enter or Space on a focused div, span, img or svg given role="button" or role="checkbox" fires a
// real click, as a native button does. A dispatched click rather than calling the handler directly:
// the activity tracker listens for click in the capture phase, so a handler call would leave every
// keyboard activation unrecorded, and mouse and keyboard keep one code path through onClick.
// dispatchEvent rather than element.click() because SVGElement has no click() (the modal close icon).
const clickOnActivateKey = (e) => {
  if (e.key !== 'Enter' && e.key !== ' ') return;
  e.preventDefault();
  e.currentTarget.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
};
export default clickOnActivateKey;
